import { render } from "./Stats.vue?vue&type=template&id=2ae7f65f&scoped=true"
import script from "./Stats.vue?vue&type=script&lang=js"
export * from "./Stats.vue?vue&type=script&lang=js"

import "./Stats.vue?vue&type=style&index=0&id=2ae7f65f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ae7f65f"],['__file',"src/scripts/view/portfolio/sections/Stats.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2ae7f65f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2ae7f65f', __exports__)) {
    api.reload('2ae7f65f', __exports__)
  }
  
  module.hot.accept("./Stats.vue?vue&type=template&id=2ae7f65f&scoped=true", () => {
    api.rerender('2ae7f65f', render)
  })

}


export default __exports__